module.exports = __webpack_public_path__ + "static/media/goblin_chief_mounted.2ffc1e3c.svg";